import throttle from 'lodash.throttle'

export const directionHandler = throttle((el: HTMLElement, direction: 'ltr' | 'rtl', resizerStyles: { [key: string]: string }) => {
  el.style.position = 'relative'
  const resizer = document.createElement('div')
  const resizeLine = document.createElement('div')
  Object.keys(resizerStyles).forEach((key: string) => {
    resizer.style.setProperty(key, resizerStyles[key]!)
  })
  el.appendChild(resizer)
  resizer.classList.add('bg-transparent')
  if (el.getAttribute('dark')) {
    resizeLine.classList.add('bg-[#202C36]')
  } else {
    resizeLine.classList.add('bg-bor-nav')
  }
  resizeLine.style.width = '1px'
  resizer.appendChild(resizeLine)
  el.addEventListener('mouseenter', () => {
    resizer.style.cursor = 'ew-resize'
  })
  el.addEventListener('mouseleave', () => {
    resizer.style.cursor = 'default'
  })

  let startX: number, startWidth: number

  const doDrag = function (e: MouseEvent) {
    document.body.style.userSelect = 'none'
    if (direction === 'ltr') {
      el.style.width = (startWidth + e.clientX - startX) + 'px'
    } else if (direction === 'rtl') {
      el.style.width = (startWidth - e.clientX + startX) + 'px'
    }
  }
  const stopDrag = function () {
    document.body.style.userSelect = 'auto'
    document.documentElement.removeEventListener('mousemove', doDrag, false)
    document.documentElement.removeEventListener('mouseup', stopDrag, false)
  }

  const startDrag = function (e: MouseEvent) {
    startX = e.clientX
    if (!document.defaultView) return
    startWidth = parseInt(document.defaultView.getComputedStyle(el).width, 10)
    document.documentElement.addEventListener('mousemove', doDrag, false)
    document.documentElement.addEventListener('mouseup', stopDrag, false)
  }

  resizer.addEventListener('mousedown', startDrag, false)
}, 50)
